export enum CONFIRM_MODAL_PREFERENCE {
  ALWAYS = "1",
  NEVER = "0"
}
